import { mapFieldToDropdown } from 'formik-office-ui-fabric-react'
import { invokeAll } from 'helpers'
import {
  Dropdown,
  IDropdownOption,
  IDropdownProps,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useOrderIdDropdownQuery } from './OrderIdDropdown.generated'

export type OrderIdDropdownProps = Omit<IDropdownProps, 'options'> & {
  validOnly?: boolean
  blacklist?: string[]
}

export const OrderIdDropdown: React.FunctionComponent<OrderIdDropdownProps> = ({
  validOnly,
  blacklist = [],
  ...props
}) => {
  const { data } = useOrderIdDropdownQuery()

  const orderIds = data && data.orderIds ? data.orderIds : []

  let options: IDropdownOption[] = orderIds.map(
    (x: { _id: any; value: any }) => ({
      key: x.value,
      text: x.value,
    })
  )

  options = blacklist
    ? options.filter(
        (option) =>
          // blacklist.indexOf(option.key as any) === -1 &&
          blacklist.indexOf(option.text) === -1
      )
    : options

  options = [{ key: '', text: '' }, ...options]

  return <Dropdown options={options} {...props} />
}

export const FormikDropdownFactory =
  (
    dropdownComponent: React.FunctionComponent<any>
  ): React.FunctionComponent<any> =>
  ({ field, form, ...props }) => {
    const DropdownComponent = dropdownComponent

    const { errorMessage, onDismiss, ...fieldProps } = mapFieldToDropdown({
      field,
      form,
    })

    return (
      <DropdownComponent
        errorMessage={errorMessage}
        {...props}
        onDismiss={invokeAll<any>(onDismiss, props.onDismiss)}
        {...fieldProps}
      />
    )
  }

export const FormikOrderIdDropdown = FormikDropdownFactory(OrderIdDropdown)

// export type OrderIdPickerProps = Omit<TagPickerCustomProps, 'tags'> & {
//   validOnly?: boolean
//   blacklist?: string[]
// }

// export const OrderIdPicker: React.FunctionComponent<OrderIdPickerProps> = ({
//   validOnly,
//   blacklist = [],
//   ...props
// }) => {
//   const { data } = useOrderIdDropdownQuery()

//   const orderIds = data && data.orderIds ? data.orderIds : []

//   let options: ITag[] = orderIds.map((x: { _id: any; value: any }) => ({
//     key: x.value,
//     name: x.value,
//   }))

//   options = blacklist
//     ? options.filter(
//         option =>
//           // blacklist.indexOf(option.key as any) === -1 &&
//           blacklist.indexOf(option.name) === -1
//       )
//     : options

//   options = [{ key: '', name: '' }, ...options]

//   return <TagPickerCustom tags={options} {...props} />
// }

// export const FormikOrderIdPicker = FormikPickerFactory(OrderIdDropdown)
